require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.create");

!function (t, e) {
  "object" == typeof exports && "undefined" != typeof module ? e(exports, require("react")) : "function" == typeof define && define.amd ? define(["exports", "react"], e) : e(t["react-web-share-api"] = t["react-web-share-api"] || {}, t.React);
}(this, function (t, e) {
  "use strict";

  function r(t, e) {
    function r() {
      this.constructor = t;
    }

    o(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
  }

  function n(t, e) {
    var r = {};

    for (var n in t) {
      Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
    }

    if (null != t && "function" == typeof Object.getOwnPropertySymbols) for (var o = 0, n = Object.getOwnPropertySymbols(t); o < n.length; o++) {
      e.indexOf(n[o]) < 0 && (r[n[o]] = t[n[o]]);
    }
    return r;
  }

  var o = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (t, e) {
    t.__proto__ = e;
  } || function (t, e) {
    for (var r in e) {
      e.hasOwnProperty(r) && (t[r] = e[r]);
    }
  },
      i = Object.assign || function (t) {
    for (var e, r = 1, n = arguments.length; r < n; r++) {
      e = arguments[r];

      for (var o in e) {
        Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
      }
    }

    return t;
  },
      c = function c(t) {
    return function () {
      return navigator.share(t.params).then(t.onShareSuccess)["catch"](t.onShareError);
    };
  };

  t["default"] = function () {
    return function (t) {
      return function (o) {
        function a() {
          return null !== o && o.apply(this, arguments) || this;
        }

        return r(a, o), a.prototype.render = function () {
          var r = this.props,
              o = r.config,
              a = n(r, ["config"]),
              p = void 0 !== navigator.share,
              u = p && o ? {
            isSupported: p,
            share: c(o)
          } : {
            isSupported: p
          };
          return e.createElement(t, i({}, a, u));
        }, a;
      }(e.Component);
    };
  }, Object.defineProperty(t, "__esModule", {
    value: !0
  });
});